import {getApiMetadata} from '../../helpers/api-metadata'
import {fetchJSONWith} from '../../platform/functional-fetch-wrapper'
import type {MemexStatus} from './contracts'

export type MemexStatusBody = {
  body: string
  startDate: string | null
  targetDate: string | null
  statusId: string | null
}

export async function apiCreateMemexStatus(body: MemexStatusBody): Promise<MemexStatus> {
  const apiData = getApiMetadata('memex-status-create-api-data')
  const {data} = await fetchJSONWith<MemexStatus>(apiData.url, {method: 'POST', body})
  return data
}
